import { jsx } from "react/jsx-runtime";
import CloseIcon from "@mui/icons-material/Close";
import { validateTidalLicense } from "../../base/index.js";
function Close(props) {
  return /* @__PURE__ */ jsx(
    CloseIcon,
    {
      "data-testid": "Close",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Close",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
Close.tidalIconMeta = {
  categories: "cancel,informative",
  name: "Close"
};
validateTidalLicense();
export {
  Close
};
//# sourceMappingURL=Close.js.map
